import { render, staticRenderFns } from "./IngredientsCard.vue?vue&type=template&id=7d3ea49d&scoped=true"
import script from "./IngredientsCard.vue?vue&type=script&lang=js"
export * from "./IngredientsCard.vue?vue&type=script&lang=js"
import style0 from "./IngredientsCard.vue?vue&type=style&index=0&id=7d3ea49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3ea49d",
  null
  
)

export default component.exports